import { formatHtml } from "@trumpf/ux.common-storybook";
import { renderPageWithMarginalColumnTemplate } from "../../../utils";
import { Template } from "./product-detail.templates";

export default {
    title: "Website/Page Templates/Product Detail",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const ProductDetailPage = () =>
    renderPageWithMarginalColumnTemplate(() => Template());
